import { getMagentoShippingMethodsApiRequest } from "../checkout/shop-checkout";
import { MagentoBookstoreAddress } from "../checkout/shop-checkout.interface";
import { mapInstructorShippingEstimationResponse } from "./instructor-sample-mapping";
import { InstructorShippingEstimation } from "./instructor-sample.interface";

export async function estimateInstructorShippingMagentoApiCall(
  requestBody: MagentoBookstoreAddress,
  token: string
): Promise<InstructorShippingEstimation[]> {
  const response = await getMagentoShippingMethodsApiRequest({ address: requestBody }, token);

  return mapInstructorShippingEstimationResponse(response);
}